import React from "react";
import Link from "next/link";
import { AiOutlineInstagram } from "react-icons/ai";
import styled from "styled-components";

const SFooter = styled.footer`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 3rem;
  background: white;
  color: #a6a6a6;
  padding: 1em
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
    li {
      margin: 0.2rem;
      padding: 0.2rem;
      font-size: 1.5rem;
    }
  }
  div,
  ul {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  a {
    color: #a6a6a6;
    transition: color 0.4s ease-in-out;
    &:hover {
      color: gray;
    }
  }
  p {
    margin: 0;
    padding: 0.5rem;
  }
  .leftalign {
    align-items: flex-start;
    text-align: left;
    margin-left: 3px;
  }
  .rightalign {
    align-items: flex-end;
    text-align: right;
    margin-left: 3px;
  }
  @media screen and (max-width: 800px) {
    font-size: 1.1rem;
    ul li {
      font-size: 1.2rem;
    }
  }
  @media screen and (max-width: 350px) {
    font-size: 1.2rem;
    ul li {
      font-size: 1.2rem;
    }
  }
`;

export const Footer = () => {
  return (
    <SFooter>
      <Wrapper>
        <ul className="leftalign">
          <li>
            <Link href="/privacy-policy">
              <a>PRIVACY POLICY</a>
            </Link>
          </li>
          <li>
            <Link href="/terms-conditions">
              <a>TERMS & CONDITIONS</a>
            </Link>
          </li>
          <li>
            <Link href="/exchange-returns">
              <a>EXCHANGE & RETURNS</a>
            </Link>
          </li>
          <li>
            <Link href="/contact">
              <a>CONTACT</a>
            </Link>
          </li>
        </ul>
      </Wrapper>
      <Wrapper>
        <p>F*CE © 2023</p>
      </Wrapper>
      <Wrapper>
        <div className="rightalign">
          Follow F*CEGUY on{" "}
          <a href="https://www.instagram.com/f_ce_guy/">Instagram</a>
        </div>
      </Wrapper>
    </SFooter>
  );
};
